module.exports = __webpack_public_path__ + "static/media/2.5525ceb1.jpg";